import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Detail as DetailComponent, InfoHeader, useRelationshipDiscoverer } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';

const dataProviderName = 'persons/employment';
const model = 'persons/employment';
const wizardName = 'Car association';
const wizardObject = 'Car';
const wizardAction = 'carAssociation';

const CarAssociation = (params) => {
    const { t } = useTranslation();
    const { userCapabilities } = useContext(AppContext);

    const { doAction, item, errorMessage, errors, saving, success } = useDataProvider(dataProviderName, params.multipart);
    const { discover } = useRelationshipDiscoverer(params, item?.data, params?.detailStack?.inverseRelation, params?.detailStack?.stack);

    const detailConfig = {
        "tabs": [
            {
                "name": "association",
                "fieldsets": [
                    {
                        "name": "association",
                        "fields": {
                            "assignment_period": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "assignment_start_at": {
                                "type": "date",
                                "className": "col-6",
                                "placeholder": "insert",
                                "icon": "faCalendarHeart"
                            },
                            "assignment_end_at": {
                                "type": "date",
                                "className": "col-6",
                                "placeholder": "insert",
                                "icon": "faCalendarXmark"
                            },
                            "available_cars": {
                                "type": "sectiontitle",
                                "className": "col-12"
                            },
                            "associated": {
                                "type": "carlist",
                                "hideTableToolbar": true,
                                "defaultSelectedValues": [],
                                "enableSelection": true,
                                "disableMultipleRowSelection": true,
                                "dataProviderName": "cars/car",
                                "filters": {
                                    "items": [
                                        {
                                            "field": "isPool",
                                            "operator": "isNot",
                                            "value": "true"
                                        },
                                        {
                                            "operator": "notHasActivePools"
                                        },
                                    ]
                                },
                                "className": "col-12",
                                "required": "true"
                            },
                        }
                    }
                ]
            }
        ],
        "validation": []
    }

    const [editing, setEditing] = useState(true)

    useEffect(() => {
        if (success && editing) {
            (async () => {
                try {
                    await params.handleClose(params.uid, item.data)
                } catch (e) { }
            })()
        }
    }, [success])

    const handleSave = (data) => {
        doAction({ action: wizardAction, model: dataProviderName, data: data });
    }

    // viene usato più volte quindi lo prendo qui
    const employment = discover('employment');
    const person = employment?.person;
    return <>
        <DetailComponent
            values={{ 
                "id": employment?._id
            }}
            modelName={model.split('/')[1]}
            detailConfig={detailConfig}
            dataProviderName={dataProviderName}
            onEditing={setEditing}
            save={handleSave}
            saving={saving}
            errors={errors}
            errorMessage={errorMessage}
            title={t(wizardName)}
            canSave={userCapabilities && userCapabilities[dataProviderName + '.' + wizardAction.toLowerCase()]}
            header={
                <InfoHeader
                    view="wizard"
                    title={t(wizardName)}
                    subtitle={t('Select a {{wizardObject}} to be associated to {{firstname}} {{lastname}}', { wizardObject: wizardObject, firstname: person?.firstname, lastname: person?.lastname })+ ' | '+ employment?.role}
                />
            }
            {...params}
        />
    </>
}

export default CarAssociation;